(function () {
  if (window.barlenOnthul) return;
  window.barlenOnthul = true;

  /* Apparaten met een muis: daar staat de knop Kopieer en opent WhatsApp in een nieuw tabblad. */
  var MUIS = '(hover: hover) and (pointer: fine)';
  /* Netnummers van twee cijfers (zonder de 0); de andere vaste nummers hebben er drie. */
  var NET2 = /^(10|13|15|20|23|24|26|30|33|35|36|38|40|43|45|46|50|53|55|58|70|71|72|73|74|75|76|77|78|79|84|85|87|88|91)/;

  function omgedraaid(tekst) {
    return tekst.split('').reverse().join('');
  }

  /* Na de eerste klik gaan de versleutelde attributen weg; de waarde blijft alleen in het geheugen van het script, zodat een
     link met een bericht bij elke klik opnieuw kan worden gemaakt. */
  var geheugen = window.WeakMap ? new WeakMap() : null;

  function waarde(knop) {
    if (geheugen && geheugen.has(knop)) return geheugen.get(knop);
    var code = (knop.getAttribute('data-bf-y') || '') + (knop.getAttribute('data-bf-x') || '');
    if (!code) return '';
    try {
      var tekst = omgedraaid(window.atob(omgedraaid(code)));
      if (geheugen && tekst) geheugen.set(knop, tekst);
      return tekst;
    } catch (fout) {
      return '';
    }
  }

  /* Een link die meteen een app opent (WhatsApp, of mail met data-bf-direct) in plaats van de waarde te tonen. Met
     data-bf-direct="aanraken" alleen op een aanraakscherm (bellen met één tik); met een muis toont de eerste klik de
     waarde, en volgt een tweede klik de link. */
  function direct(knop, soort) {
    if (soort === 'wa') return true;
    var d = knop.getAttribute('data-bf-direct');
    if (d === null) return false;
    if (d === 'aanraken') return !(window.matchMedia && window.matchMedia(MUIS).matches);
    return true;
  }

  /* Internationaal: een Nederlands nummer (0…, 0031… of +31 (0)…) wordt +31 met de rest zonder de 0. */
  function internationaal(tekst) {
    var nummer = tekst.replace(/[^0-9+]/g, '');
    if (nummer.indexOf('00') === 0) nummer = '+' + nummer.slice(2);
    else if (nummer.charAt(0) === '0') nummer = '+31' + nummer.slice(1);
    if (nummer.indexOf('+310') === 0) nummer = '+31' + nummer.slice(4);
    return nummer;
  }

  /* Leesbaar: +31 6 12 34 56 78 (mobiel), +31 20 123 4567 of +31 481 123 456 (vast), +31 800 1234 (gratis of
     betaald). Een nummer uit een ander land blijft zoals het is ingevuld. */
  function notatie(tekst) {
    var nummer = internationaal(tekst);
    if (nummer.indexOf('+31') !== 0) return tekst.trim();
    var rest = nummer.slice(3);
    if (/^(800|90[069])/.test(rest)) return '+31 ' + rest.slice(0, 3) + ' ' + rest.slice(3);
    if (rest.length !== 9) return '+31 ' + rest;
    if (rest.charAt(0) === '6') return '+31 6 ' + rest.slice(1).replace(/(\d\d)(?=\d)/g, '$1 ');
    if (NET2.test(rest)) return '+31 ' + rest.slice(0, 2) + ' ' + rest.slice(2, 5) + ' ' + rest.slice(5);
    return '+31 ' + rest.slice(0, 3) + ' ' + rest.slice(3, 6) + ' ' + rest.slice(6);
  }

  function adres(soort, tekst, knop) {
    if (soort === 'tel') return 'tel:' + internationaal(tekst);
    var bericht = (knop.getAttribute('data-bf-bericht') || '').trim();
    if (soort === 'wa') {
      /* wa.me/<nummer>: internationaal, zonder plus, spaties of streepjes; het bericht URL-gecodeerd. */
      return 'https://wa.me/' + internationaal(tekst).replace(/\D/g, '') + (bericht ? '?text=' + encodeURIComponent(bericht) : '');
    }
    /* Mail die meteen opent: onderwerp en bericht in de link; regels met CRLF, zoals mailto-links dat vragen. */
    var delen = [];
    if (knop.hasAttribute('data-bf-direct')) {
      var onderwerp = (knop.getAttribute('data-bf-onderwerp') || '').trim();
      if (onderwerp) delen.push('subject=' + encodeURIComponent(onderwerp));
      if (bericht) delen.push('body=' + encodeURIComponent(bericht.replace(/\r?\n/g, '\r\n')));
    }
    return 'mailto:' + tekst + (delen.length ? '?' + delen.join('&') : '');
  }

  /* Melding voor schermlezers. Met "opnieuw" eerst leeg en dan de tekst, zodat ook een herhaalde melding klinkt. */
  function melden(binnen, tekst, opnieuw) {
    var blok = binnen.closest('[data-bf-contact]');
    var melding = blok ? blok.querySelector('[data-bf-melding]') : null;
    if (!melding) return;
    if (!opnieuw) {
      melding.textContent = tekst;
      return;
    }
    melding.textContent = '';
    window.setTimeout(function () { melding.textContent = tekst; }, 100);
  }

  /* Terugval als het klembord van de browser niet mag: een onzichtbaar tekstveld kopiëren. */
  function kopieerOud(tekst) {
    var focus = document.activeElement;
    var veld = document.createElement('textarea');
    veld.value = tekst;
    veld.setAttribute('readonly', '');
    veld.setAttribute('aria-hidden', 'true');
    veld.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;';
    document.body.appendChild(veld);
    veld.select();
    var gelukt = false;
    try {
      gelukt = document.execCommand('copy');
    } catch (fout) {
      gelukt = false;
    }
    document.body.removeChild(veld);
    if (focus && focus.focus) focus.focus();
    return gelukt;
  }

  function bevestig(knop, veld, gelukt) {
    window.clearTimeout(knop.bfKlok);
    if (gelukt) {
      knop.setAttribute('data-bf-klaar', 'true');
      knop.bfKlok = window.setTimeout(function () { knop.removeAttribute('data-bf-klaar'); }, 2000);
      melden(knop, knop.getAttribute('data-bf-gekopieerd') || '', true);
      return;
    }
    /* Ook de terugval lukte niet: de waarde selecteren, dan kan de bezoeker zelf kopiëren. */
    knop.removeAttribute('data-bf-klaar');
    var keuze = window.getSelection ? window.getSelection() : null;
    if (keuze) {
      var stuk = document.createRange();
      stuk.selectNodeContents(veld);
      keuze.removeAllRanges();
      keuze.addRange(stuk);
    }
    melden(knop, knop.getAttribute('data-bf-mislukt') || '', true);
  }

  function kopieer(knop) {
    var rij = knop.closest('[data-bf-rij]');
    var link = rij ? rij.querySelector('a[data-bf-onthul]') : null;
    var veld = rij ? rij.querySelector('[data-bf-waarde]') : null;
    if (!link || !veld || link.getAttribute('data-bf-open') !== 'true') return;
    var tekst = veld.textContent.trim();
    if (!tekst) return;
    var terugval = function () { bevestig(knop, veld, kopieerOud(tekst)); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(tekst).then(function () { bevestig(knop, veld, true); }, terugval);
    } else {
      terugval();
    }
  }

  document.addEventListener('click', function (gebeurtenis) {
    var doel = gebeurtenis.target;
    if (!doel || !doel.closest) return;
    var kopieerKnop = doel.closest('[data-bf-kopieer]');
    if (kopieerKnop) {
      kopieer(kopieerKnop);
      return;
    }
    var knop = doel.closest('a[data-bf-onthul]');
    if (!knop) return;
    var soort = knop.getAttribute('data-bf-onthul');
    /* Een link die een app opent, wordt bij elke klik opnieuw gemaakt: het bericht kan intussen veranderd zijn (een andere
       maat of kleur). Een getoonde waarde blijft staan. */
    var meteen = direct(knop, soort);
    if (!meteen && knop.getAttribute('data-bf-open') === 'true') return;
    var tekst = waarde(knop);
    if (!tekst) return;
    knop.setAttribute('href', adres(soort, tekst, knop));
    knop.setAttribute('data-bf-open', 'true');
    knop.removeAttribute('data-bf-x');
    knop.removeAttribute('data-bf-y');
    if (meteen) {
      /* Geen tussenstap: de browser volgt meteen de nieuwe link. WhatsApp met een muis in een nieuw tabblad, op een
         aanraakscherm in hetzelfde tabblad, zodat de app opent. Mail opent het mailprogramma. */
      if (soort === 'wa' && window.matchMedia && window.matchMedia(MUIS).matches) {
        knop.setAttribute('target', '_blank');
        knop.setAttribute('rel', 'noopener');
      }
      return;
    }
    gebeurtenis.preventDefault();
    var getoond = soort === 'tel' ? notatie(tekst) : tekst;
    var veld = knop.querySelector('[data-bf-waarde]');
    if (veld) veld.textContent = getoond;
    var rij = knop.closest('[data-bf-rij]');
    if (rij) rij.setAttribute('data-bf-open', 'true');
    melden(knop, getoond);
  }, true);

  /* Een link met data-bf-toon toont de waarde al na het laden, als gewone link (mailto of tel), zonder klik. In de HTML
     staat de waarde nog steeds niet leesbaar. Ook voor wat later in de pagina komt, zoals de inhoud van de zijwagen. */
  function toonMeteen() {
    var links = document.querySelectorAll('a[data-bf-onthul][data-bf-toon][data-bf-x]');
    for (var i = 0; i < links.length; i++) {
      var knop = links[i];
      var soort = knop.getAttribute('data-bf-onthul');
      if (soort === 'wa') continue;
      var tekst = waarde(knop);
      if (!tekst) continue;
      knop.setAttribute('href', adres(soort, tekst, knop));
      knop.setAttribute('data-bf-open', 'true');
      knop.removeAttribute('data-bf-x');
      knop.removeAttribute('data-bf-y');
      var veld = knop.querySelector('[data-bf-waarde]');
      if (veld) veld.textContent = soort === 'tel' ? notatie(tekst) : tekst;
    }
  }
  function begin() {
    toonMeteen();
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      if (document.querySelector('a[data-bf-toon][data-bf-x]')) toonMeteen();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin);
  else begin();
})();
